import {
  AISchedule,
  AIScheduleConversation,
  AIScheduleParticipantSettings,
  AISchedulePayload,
} from '../@types/ai-schedules';
import { axios } from '../utils/axios';
import { VoiceChannelToken } from './chat';

export const fetchAISchedules = async () => {
  const { data } = await axios.get<AISchedule[]>('/ai-call');
  return data;
};

export const getAISchedulesById = async (scheduleId: string) => {
  const { data } = await axios.get<AISchedule>(`/ai-call/${scheduleId}`);
  return data;
};

export const createAISchedule = async (params: AISchedulePayload) => {
  const { data } = await axios.post<AISchedule>('/ai-call/create', params);
  return data;
};

export const updateAISchedule = async (
  scheduleId: string,
  params: Partial<AISchedulePayload>,
) => {
  const { data } = await axios.put<AISchedule>(
    `/ai-call/update/${scheduleId}`,
    params,
  );
  return data;
};

export const deleteAISchedule = async (scheduleId: string) => {
  const { data } = await axios.delete<AISchedule>(`/ai-call/${scheduleId}`);
  return data;
};

export type AddRemoveAIScheduleParticipants = {
  id: string;
  participants: { _id: string }[];
};

export const addAIScheduleParticipants = async (
  params: AddRemoveAIScheduleParticipants,
) => {
  const { data } = await axios.put<AISchedule>(
    '/ai-call/participant/add',
    params,
  );
  return data;
};

export const changeParticipantLanguage = async (
  params: AIScheduleParticipantSettings,
) => {
  const { data } = await axios.put<AISchedule>(
    '/ai-call/participant/settings',
    params,
  );
  return data;
};

export const removeAIScheduleParticipants = async (
  params: AddRemoveAIScheduleParticipants,
) => {
  const { data } = await axios.put<AISchedule>(
    '/ai-call/participant/remove',
    params,
  );
  return data;
};

export const getAISchedulesConversationDatesByParticipantId = async (
  scheduleId: string,
  participantId: string,
) => {
  const { data } = await axios.get<string[]>(
    `/ai-call/${scheduleId}/participant/${participantId}/conversation/dates`,
  );
  return data;
};

export const getAISchedulesConversationByParticipantId = async (
  scheduleId: string,
  participantId: string,
  date: string,
) => {
  const { data } = await axios.get<AIScheduleConversation[]>(
    `/ai-call/${scheduleId}/participant/${participantId}/conversation`,
    {
      params: date ? { date } : null,
    },
  );
  return data;
};

export const getAICallToken = async (aiCallId: string) => {
  const { data } = await axios.post<VoiceChannelToken>(
    `/chat/channel/voice/assistant/token/${aiCallId}`,
  );
  return data;
};

export const getAIScheduleCallToken = async (aiCallId: string) => {
  const { data } = await axios.post<VoiceChannelToken>(
    `/ai-call/get-token/${aiCallId}`,
  );
  return data;
};

export const acceptAICall = async (aiCallId: string) => {
  await axios.post('/ai-call/call/accept', { aiCallId });
};

export const declineAICall = async (aiCallId: string) => {
  await axios.post('/ai-call/call/decline', { aiCallId });
};

export * as AIScheduleRequests from './ai-schedules';
